module.exports = __webpack_public_path__ + "img/scattering.0e46bd55.png";